module.exports = __webpack_public_path__ + "img/zwx.445ab4c8.gif";